import {
    GET_ALL_MODULES_REQUEST,
    GET_ALL_MODULES_SUCCESS,
    GET_ALL_MODULES_FAIL,
    SAVE_ENTITY_MODULES_REQUEST,
    SAVE_ENTITY_MODULES_SUCCESS,
    SAVE_ENTITY_MODULES_FAIL,
    GET_ENTITY_MODULES_REQUEST,
    GET_ENTITY_MODULES_SUCCESS,
    GET_ENTITY_MODULES_FAIL,
} from "../../types/admin/moduleTypes";

export const getAllModulesReducer = (state = { modules: [] }, action) => {
    switch (action.type) {
        case GET_ALL_MODULES_REQUEST:
            return { loading: true, modules: [] };
        case GET_ALL_MODULES_SUCCESS:
            return { loading: false, modules: action.payload };
        case GET_ALL_MODULES_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const saveEntityModulesReducer = (state = {}, action) => {
    switch (action.type) {
        case SAVE_ENTITY_MODULES_REQUEST:
            return { loading: true };
        case SAVE_ENTITY_MODULES_SUCCESS:
            return { loading: false, success: true, data: action.payload };
        case SAVE_ENTITY_MODULES_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const getEntityModulesReducer = (state = { selectedModuleRoles: {} }, action) => {
    switch (action.type) {
        case GET_ENTITY_MODULES_REQUEST:
            return { loading: true, selectedModuleRoles: {} };
        case GET_ENTITY_MODULES_SUCCESS:
            return { loading: false, selectedModuleRoles: action.payload };
        case GET_ENTITY_MODULES_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};
